import { useEffect } from "react";

// Блокировка скролла страницы под открытыми попапом
export const useScrollLock = (locked: boolean) => {
  useEffect(() => {
    if (locked) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [locked]);
};
